export default "__VITE_ASSET__CZz_yJTH__"